import gql from 'graphql-tag'

export const POSTSLM = gql`
  mutation postSLM($postSLMInput: PostSLMInput!) {
    postSLM(postSLMInput: $postSLMInput) {
      ServiceStatus {
        StatusCode
        Success
        Message
      }
      Response {
        SkillsAttempsRemaining
        Status
        RecordId
      }
    }
  }
`
